module.exports = __webpack_public_path__ + "static/media/icon_drop_point.dd7ca07e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/icon_drop_point.svg
// module id = 1848
// module chunks = 0